import { 
  CartUpdateEvent,
  TransitionEndEvent,
} from '@mockly/events';

const endpoints = {
  load: '/cart.js',
  add: '/cart/add.js',
  update: '/cart/update.js',
  change: '/cart/change.js',
}

class Cart {
  constructor() {
    this.data = null;

    this.renderSection = this.renderSection.bind(this);
    this.cartDrawer = document.getElementById('cart-drawer');

    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);

    this.setupEventListeners();
  }

  handleTransitionEnd() {
    this.cartDrawer = document.getElementById('cart-drawer');
  }

  setupEventListeners() {
    window.addEventListener(TransitionEndEvent.eventName, this.handleTransitionEnd);
  }

  async renderSection() {
    const cartDrawer = document.getElementById('cart-drawer');
    
    const newSection = await fetch(`?sections=cart`)
    const newSectionData = await newSection.json();

    if (newSectionData?.cart && cartDrawer) {
      const parser = new DOMParser();
      const parsedSectionData = parser.parseFromString(newSectionData.cart, 'text/html');
      const content = parsedSectionData.querySelector('.cart__content');
      cartDrawer.innerHTML = content?.innerHTML;
    }
  }

  async load() {
    const response = await fetch(endpoints.load);
    const data = await response.json();
    
    this.data = data;

    window.dispatchEvent(new CartUpdateEvent(this.data));
  }

  async add(data) {
    if (!data?.items) {
      throw new Error('No items found in cart add data');
      return;
    }

    try {
      const response = await fetch(endpoints.add, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
        return;
      }
      
      this.renderSection();
      await this.load();
    } catch (error) {
      throw new Error(error?.message ?? 'Failed to add items to cart');
    }
  }

  async update({ id, quantity }) {
    if (!id || typeof quantity !== 'number') {
      throw new Error('ID and Quantity are required in cart.update()');
      return;
    }

    let updates = {};
    updates[id] = quantity;

    try {
      await fetch(endpoints.update, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });
      
      await this.load();
    } catch (error) {
      throw new Error('Failed to update cart', error);
      return;
    }
  }

  async remove(id) {
    if (!id) {
      throw new Error('ID is required in cart.remove()');
      return;
    }

    let updates = {};
    updates[id] = 0;

    try {
      await fetch(endpoints.update, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });
      
      this.renderSection();
      await this.load();
    } catch (error) {
      throw new Error('Failed to update cart', error);
      return;
    }
  }
}

export const cart = new Cart();